<nav
  class="navbar navbar-expand-lg fixed-top navbar-transparent"
  color-on-scroll="100"
  id="navbar-top"
>
  <div class="container">
    <div class="navbar-translate">
      <a
        class="navbar-brand"
        placement="bottom"
        [routerLink]="['/home']"
        target="_blank"
        tooltip="Designed and Coded by Creative Tim"
      >
        <span> BLK• </span> Design System Angular
      </a>
      <button
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
        class="navbar-toggler navbar-toggler"
        [attr.aria-expanded]="!isCollapsed"
        (click)="isCollapsed = !isCollapsed"
        id="navigation"
        type="button"
      >
        <span class="navbar-toggler-bar bar1"> </span>
        <span class="navbar-toggler-bar bar2"> </span>
        <span class="navbar-toggler-bar bar3"> </span>
      </button>
    </div>
    <div
      class="navbar-collapse justify-content-end"
      [collapse]="isCollapsed"
      id="navigation"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand"><a> BLK• </a></div>
          <div class="col-6 collapse-close text-right">
            <button
              aria-controls="navigation-index"
              aria-label="Toggle navigation"
              class="navbar-toggler"
              [attr.aria-expanded]="!isCollapsed"
              (click)="isCollapsed = !isCollapsed"
              id="navigation"
              type="button"
            >
              <i class="tim-icons icon-simple-remove"> </i>
            </button>
          </div>
        </div>
      </div>
      <ul class="navbar-nav">
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://twitter.com/CreativeTim"
            placement="bottom"
            target="_blank"
            tooltip="Follow us on Twitter"
          >
            <i class="fab fa-twitter"> </i>
            <p class="d-lg-none d-xl-none">Twitter</p>
          </a>
        </li>
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://www.facebook.com/CreativeTim"
            placement="bottom"
            target="_blank"
            tooltip="Like us on Facebook"
          >
            <i class="fab fa-facebook-square"> </i>
            <p class="d-lg-none d-xl-none">Facebook</p>
          </a>
        </li>
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://www.instagram.com/CreativeTimOfficial"
            placement="bottom"
            target="_blank"
            tooltip="Follow us on Instagram"
          >
            <i class="fab fa-instagram"> </i>
            <p class="d-lg-none d-xl-none">Instagram</p>
          </a>
        </li>
        <li class="dropdown nav-item" dropdown>
          <a
            class="dropdown-toggle nav-link dropdown-toggle"
            data-toggle="dropdown"
            dropdownToggle
            href="javascript:void(0)"
          >
            <i class="fa fa-cogs d-lg-none d-xl-none"> </i> Getting started
          </a>
          <div class="dropdown-menu dropdown-with-icons" *dropdownMenu>
            <a
              class="dropdown-item"
              href="https://demos.creative-tim.com/blk-design-system-angular/#/documentation/overview"
            >
              <i class="tim-icons icon-paper"> </i> Documentation
            </a>
            <a class="dropdown-item" [routerLink]="['/register']">
              <i class="tim-icons icon-bullet-list-67"> </i> Register Page
            </a>
            <a class="dropdown-item" [routerLink]="['/landing']">
              <i class="tim-icons icon-image-02"> </i> Landing Page
            </a>
            <a class="dropdown-item" [routerLink]="['/profile']">
              <i class="tim-icons icon-single-02"> </i> Profile Page
            </a>
          </div>
        </li>
        <li class="nav-item">
          <a
            class="nav-link btn btn-default d-none d-lg-block"
            href="javascript:void(0)"
            (click)="scrollToDownload(target)"
          >
            <i class="tim-icons icon-cloud-download-93"> </i> Download
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="wrapper">
  <div class="page-header header-filter">
    <div class="squares square1"></div>
    <div class="squares square2"></div>
    <div class="squares square3"></div>
    <div class="squares square4"></div>
    <div class="squares square5"></div>
    <div class="squares square6"></div>
    <div class="squares square7"></div>
    <div class="container">
      <div class="content-center brand">
        <h1 class="h1-seo">BLK•</h1>
        <h3>
          A beautiful Design System for Bootstrap 4 and Angular. It's Free and
          Open Source.
        </h3>
      </div>
    </div>
  </div>
  <div class="main">
    <div class="section section-basic" id="basic-elements">
      <img class="path" src="assets/img/path1.png" />

      <div class="container">
        <h2 class="title">Basic Elements</h2>
        <h3>Buttons</h3>
        <p class="category">Pick your style</p>
        <div class="row">
          <div class="col-md-10">
            <button class="btn btn-primary mr-1" type="button">Default</button>
            <button class="btn btn-primary btn-round mr-1" type="button">
              Round
            </button>
            <button class="btn btn-primary btn-round mr-1" type="button">
              <i class="tim-icons icon-heart-2"> </i> With Icon
            </button>
            <button
              class="btn btn-primary btn-icon btn-round mr-1"
              type="button"
            >
              <i class="tim-icons icon-heart-2"> </i>
            </button>
            <button class="btn btn-primary btn-simple btn-round" type="button">
              Simple
            </button>
          </div>
        </div>
        <p class="category">Pick your size</p>
        <div class="row">
          <div class="col-md-10">
            <button class="btn btn-primary btn-sm mr-1">Small</button>
            <button class="btn btn-primary mr-1">Regular</button>
            <button class="btn btn-primary btn-lg">Large</button>
          </div>
        </div>
        <p class="category">Pick your color</p>
        <div class="row">
          <div class="col-md-12">
            <button class="btn mr-1">Default</button>
            <button class="btn btn-primary mr-1">Primary</button>
            <button class="btn btn-info mr-1">Info</button>
            <button class="btn btn-success mr-1">Success</button>
            <button class="btn btn-warning mr-1">Warning</button>
            <button class="btn btn-danger mr-1">Danger</button>
            <button class="btn btn-neutral">Neutral</button>
          </div>
        </div>
        <br />

        <h3>Links</h3>
        <div class="row">
          <div class="col-md-8">
            <button class="btn btn-link mr-1">Default</button>
            <button class="btn btn-link btn-primary mr-1">Primary</button>
            <button class="btn btn-link btn-info mr-1">Info</button>
            <button class="btn btn-link btn-success mr-1">Success</button>
            <button class="btn btn-link btn-warning mr-1">Warning</button>
            <button class="btn btn-link btn-danger">Danger</button>
          </div>
        </div>
        <div class="space-70"></div>
        <div id="inputs">
          <h3>Inputs</h3>
          <p class="category">Form Controls</p>
          <div class="row">
            <div class="col-sm-6 col-lg-3">
              <div class="form-group">
                <input
                  class="form-control"
                  placeholder="Regular"
                  type="text"
                  value=""
                />
              </div>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="form-group has-success">
                <input
                  class="form-control form-control-success"
                  type="text"
                  value="Success"
                />
              </div>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="form-group has-danger">
                <input
                  class="form-control form-control-danger"
                  type="email"
                  value="Error Input"
                />
              </div>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div
                class="input-group"
                [ngClass]="{ 'input-group-focus': focus === true }"
              >
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-user"> </i>
                  </span>
                </div>
                <input
                  class="form-control"
                  placeholder="Left Font Awesome Icon"
                  type="text"
                  (focus)="focus = true"
                  (blur)="focus = false"
                />
              </div>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="Right Nucleo Icon"
                  type="text"
                />

                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="tim-icons icon-lock-circle"> </i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="space-70"></div>
        <div class="row" id="checkRadios">
          <div class="col-sm-6 col-lg-3">
            <p class="category">Checkboxes</p>
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" />

                <span class="form-check-sign"> </span> Unchecked
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input
                  checked="checked"
                  class="form-check-input"
                  type="checkbox"
                />

                <span class="form-check-sign"> </span> Checked
              </label>
            </div>
            <div class="form-check disabled">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  disabled="disabled"
                  type="checkbox"
                />

                <span class="form-check-sign"> </span> Disabled Unchecked
              </label>
            </div>
            <div class="form-check disabled">
              <label class="form-check-label">
                <input
                  checked="checked"
                  class="form-check-input"
                  disabled="disabled"
                  type="checkbox"
                />

                <span class="form-check-sign"> </span> Disabled Checked
              </label>
            </div>
          </div>
          <div class="col-sm-6 col-lg-3">
            <p class="category">Radios</p>
            <div class="form-check form-check-radio">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  id="exampleRadios1"
                  name="exampleRadios"
                  type="radio"
                  value="option1"
                />

                <span class="form-check-sign"> </span> Radio is off
              </label>
            </div>
            <div class="form-check form-check-radio">
              <label class="form-check-label">
                <input
                  checked="checked"
                  class="form-check-input"
                  id="exampleRadios1"
                  name="exampleRadios"
                  type="radio"
                  value="option2"
                />

                <span class="form-check-sign"> </span> Radio is on
              </label>
            </div>
            <div class="form-check form-check-radio disabled">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  disabled="disabled"
                  id="exampleRadios2"
                  name="exampleRadios1"
                  type="radio"
                  value="option3"
                />

                <span class="form-check-sign"> </span> Disabled radio is off
              </label>
            </div>
            <div class="form-check form-check-radio disabled">
              <label class="form-check-label">
                <input
                  checked="checked"
                  class="form-check-input"
                  disabled="disabled"
                  id="exampleRadios2"
                  name="exampleRadios1"
                  type="radio"
                  value="option4"
                />

                <span class="form-check-sign"> </span> Disabled radio is on
              </label>
            </div>
          </div>
          <div class="col-sm-6 col-lg-3">
            <p class="category">Toggle Buttons</p>
            <bSwitch
              [switch-on-color]="'danger'"
              [switch-off-color]="'danger'"
              [switch-off-text]="' '"
              [switch-on-text]="' '"
            >
            </bSwitch>
            <br />
            <bSwitch [switch-on-color]="'danger'" [switch-off-color]="'danger'">
            </bSwitch>
          </div>
          <div class="col-sm-6 col-lg-3">
            <p class="category">Sliders</p>
            <div class="slider" id="sliderRegular"></div>
            <br />

            <div class="slider slider-danger" id="sliderDouble"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-navbars">
      <img class="path" src="assets/img/path3.png" />

      <div class="container" id="menu-dropdown">
        <div class="row">
          <div class="col-md-6">
            <h4>Menu</h4>
            <nav class="navbar navbar-expand-lg bg-primary">
              <div class="container">
                <a class="navbar-brand" href="javascript:void(0)"> Menu </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
                <div
                  class="navbar-collapse"
                  [isAnimated]="true"
                  [collapse]="isCollapsed"
                  id="example-navbar"
                >
                  <ul class="navbar-nav">
                    <li class="nav-item active">
                      <a class="nav-link" href="javascript:void(0)">
                        <p>Link</p>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)">
                        <p>Link</p>
                      </a>
                    </li>
                    <li class="nav-item dropdown" dropdown>
                      <a
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="nav-link dropdown-toggle dropdown-toggle"
                        data-toggle="dropdown"
                        dropdownToggle
                        href="javascript:void(0)"
                        id="navbarDropdownMenuLink"
                      >
                        <p>Dropdown</p>
                      </a>
                      <div
                        aria-labelledby="navbarDropdownMenuLink"
                        class="dropdown-menu"
                        *dropdownMenu
                      >
                        <a class="dropdown-item" href="javascript:void(0)">
                          Action
                        </a>
                        <a class="dropdown-item" href="javascript:void(0)">
                          Another action
                        </a>
                        <a class="dropdown-item" href="javascript:void(0)">
                          Something else here
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
          <div class="col-md-6">
            <h4>Menu with Icons</h4>
            <nav class="navbar navbar-expand-lg bg-info">
              <div class="container">
                <a class="navbar-brand" href="javascript:void(0)"> Icons </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-icons"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
                <div
                  class="navbar-collapse"
                  [isAnimated]="true"
                  [collapse]="isCollapsed"
                  id="example-navbar-icons"
                >
                  <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)">
                        <i aria-hidden="true" class="tim-icons icon-send"> </i>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)">
                        <i aria-hidden="true" class="tim-icons icon-single-02">
                        </i>
                      </a>
                    </li>
                    <li class="nav-item dropdown" dropdown>
                      <a
                        class="nav-link dropdown-toggle dropdown-toggle"
                        data-toggle="dropdown"
                        dropdownToggle
                        href="javascript:void(0)"
                        id="navbarDropdownMenuLink"
                      >
                        <i
                          aria-hidden="true"
                          class="tim-icons icon-settings-gear-63"
                        >
                        </i>
                      </a>
                      <div
                        aria-labelledby="navbarDropdownMenuLink"
                        class="dropdown-menu dropdown-menu-right"
                        *dropdownMenu
                      >
                        <a class="dropdown-header"> Dropdown header </a>
                        <a class="dropdown-item" href="javascript:void(0)">
                          Action
                        </a>
                        <a class="dropdown-item" href="javascript:void(0)">
                          Another action
                        </a>
                        <a class="dropdown-item" href="javascript:void(0)">
                          Something else here
                        </a>
                        <div class="divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)">
                          Separated link
                        </a>
                        <div class="divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)">
                          One more separated link
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <h3 class="title mb-3">Navigation</h3>
      </div>
      <div id="navbar">
        <div class="navigation-example">
          <nav class="navbar navbar-expand-lg bg-primary">
            <div class="container">
              <div class="navbar-translate">
                <a class="navbar-brand" href="javascript:void(0)">
                  Primary color
                </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-primary"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
              </div>
              <div
                class="navbar-collapse"
                [isAnimated]="true"
                [collapse]="isCollapsed"
                id="example-navbar-primary"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item active">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="tim-icons icon-world"> </i> Discover
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="tim-icons icon-single-02"> </i> Profile
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="tim-icons icon-settings-gear-63"> </i> Settings
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <nav class="navbar navbar-expand-lg bg-info">
            <div class="container">
              <div class="navbar-translate">
                <a class="navbar-brand" href="javascript:void(0)">
                  Info Color
                </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-info"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
              </div>
              <div
                class="navbar-collapse"
                [isAnimated]="true"
                [collapse]="isCollapsed"
                id="example-navbar-info"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item active">
                    <a class="nav-link" href="javascript:void(0)"> Discover </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)"> Profile </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)"> Settings </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <nav class="navbar navbar-expand-lg bg-success">
            <div class="container">
              <div class="navbar-translate">
                <a class="navbar-brand" href="javascript:void(0)">
                  Success Color
                </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-success"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
              </div>
              <div
                class="navbar-collapse"
                [isAnimated]="true"
                [collapse]="isCollapsed"
                id="example-navbar-success"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item active">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="tim-icons icon-world"> </i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="tim-icons icon-single-02"> </i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="tim-icons icon-settings-gear-63"> </i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <nav class="navbar navbar-expand-lg bg-warning">
            <div class="container">
              <div class="navbar-translate">
                <a class="navbar-brand" href="javascript:void(0)">
                  Warning Color
                </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-warning"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
              </div>
              <div
                class="navbar-collapse"
                [isAnimated]="true"
                [collapse]="isCollapsed"
                id="example-navbar-warning"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-facebook-square"> </i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-twitter"> </i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-google-plus"> </i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-instagram"> </i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <nav class="navbar navbar-expand-lg bg-danger">
            <div class="container">
              <div class="navbar-translate">
                <a class="navbar-brand" href="javascript:void(0)">
                  Danger Color
                </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-danger"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
              </div>
              <div
                class="navbar-collapse"
                [isAnimated]="true"
                [collapse]="isCollapsed"
                id="example-navbar-danger"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-facebook-square"> </i> Share
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-twitter"> </i> Tweet
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-pinterest"> </i> Pin
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <nav class="navbar navbar-expand-lg navbar-transparent">
            <div class="container">
              <div class="navbar-translate">
                <a class="navbar-brand" href="javascript:void(0)">
                  Transparent
                </a>
                <button
                  aria-controls="navbarSupportedContent"
                  aria-label="Toggle navigation"
                  class="navbar-toggler"
                  [attr.aria-expanded]="!isCollapsed"
                  (click)="isCollapsed = !isCollapsed"
                  id="example-navbar-transparent"
                  type="button"
                >
                  <span class="navbar-toggler-bar bar1"> </span>
                  <span class="navbar-toggler-bar bar2"> </span>
                  <span class="navbar-toggler-bar bar3"> </span>
                </button>
              </div>
              <div
                class="navbar-collapse"
                [isAnimated]="true"
                [collapse]="isCollapsed"
                id="example-navbar-transparent"
              >
                <ul class="navbar-nav ml-auto">
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-facebook-square"> </i> Facebook
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-twitter"> </i> Twitter
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)">
                      <i class="fab fa-instagram"> </i> Instagram
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div class="section section-tabs">
      <div class="container">
        <div class="title"><h3 class="mb-3">Navigation Tabs</h3></div>
        <div class="row">
          <div class="col-md-10 ml-auto col-xl-6 mr-auto">
            <div class="mb-3">
              <small class="text-uppercase font-weight-bold">
                With icons
              </small>
            </div>
            <div class="card">
              <div class="card-header">
                <tabset class="nav-tabs-danger">
                  <tab>
                    <ng-template tabHeading>
                      <i class="tim-icons icon-spaceship"> </i> Profile
                    </ng-template>
                    <p>
                      Collaboratively administrate empowered markets via
                      plug-and-play networks. Dynamically procrastinate B2C
                      users after installed base benefits. <br />

                      <br />

                      Dramatically visualize customer directed convergence
                      without revolutionary ROI.
                    </p>
                  </tab>
                  <tab>
                    <ng-template tabHeading>
                      <i class="tim-icons icon-settings-gear-63"> </i> Settings
                    </ng-template>
                    <p>
                      Completely synergize resource taxing relationships via
                      premier niche markets. Professionally cultivate one-to-one
                      customer service with robust ideas. <br />

                      <br />

                      Dynamically innovate resource-leveling customer service
                      for state of the art customer service.
                    </p>
                  </tab>
                  <tab>
                    <ng-template tabHeading>
                      <i class="tim-icons icon-bag-16"> </i> Options
                    </ng-template>
                    <p>
                      Efficiently unleash cross-media information without
                      cross-media value. Quickly maximize timely deliverables
                      for real-time schemas. <br />

                      <br />

                      Dramatically maintain clicks-and-mortar solutions without
                      functional solutions.
                    </p>
                  </tab>
                </tabset>
              </div>
            </div>
          </div>
          <div class="col-md-10 ml-auto col-xl-6 mr-auto">
            <div class="mb-3">
              <small class="text-uppercase font-weight-bold"> With text </small>
            </div>
            <div class="card">
              <div class="card-header">
                <tabset class="nav-tabs-danger">
                  <tab heading="Profile">
                    <p>
                      These cases are perfectly simple and easy to distinguish.
                      In a free hour, when our power of choice is untrammelled
                      and when nothing prevents our being able to do what we
                      like best, every pleasure is to be welcomed and every pain
                      avoided. <br />

                      But in certain circumstances and owing to the claims of
                      duty or the obligations of business it will frequently
                      occur that pleasures
                    </p>
                  </tab>
                  <tab heading="Settings">
                    <p>
                      I will be the leader of a company that ends up being worth
                      billions of dollars, because I got the answers. I
                      understand culture. I am the nucleus. I think thatâs a
                      responsibility that I have, to push possibilities, to show
                      people, this is the level that things could be at. I think
                      thatâs a responsibility that I have, to push
                      possibilities, to show people, this is the level that
                      things could be at.
                    </p>
                  </tab>
                  <tab heading="Options">
                    <p>
                      I think thatâs a responsibility that I have, to push
                      possibilities, to show people, this is the level that
                      things could be at. So when you get something that has the
                      name Kanye West on it, itâs supposed to be pushing the
                      furthest possibilities. I will be the leader of a company
                      that ends up being worth billions of dollars, because I
                      got the answers. I understand culture. I am the nucleus.
                    </p>
                  </tab>
                </tabset>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-pagination">
      <img class="path" src="assets/img/path4.png" />

      <img class="path path1" src="assets/img/path5.png" />

      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h3 class="mb-4">Progress Bars</h3>
            <div class="progress-container">
              <span class="progress-badge"> Default </span>
              <progressbar [value]="25">
                <span class="progress-value"> 25% </span>
              </progressbar>
            </div>
            <div class="progress-container progress-danger">
              <span class="progress-badge"> Danger </span>
              <progressbar class="progress-bar-danger" [value]="60">
                <span class="progress-value"> 60% </span>
              </progressbar>
            </div>
            <br />

            <h3 class="mb-5">Navigation Pills</h3>
            <tabset type="pills" class="nav-pills-danger nav-pills-icons">
              <tab>
                <ng-template tabHeading>
                  <i class="tim-icons icon-atom"> </i> Home
                </ng-template>
              </tab>
              <tab>
                <ng-template tabHeading>
                  <i class="tim-icons icon-chat-33"> </i> Messages
                </ng-template>
              </tab>
              <tab>
                <ng-template tabHeading>
                  <i class="tim-icons icon-settings-gear-63"> </i> Settings
                </ng-template>
              </tab>
            </tabset>
          </div>
          <div class="col-md-6">
            <h3 class="mb-5">Pagination</h3>
            <pagination
              class="pagination-danger"
              [(ngModel)]="pagination1"
              [totalItems]="30"
            >
            </pagination>
            <pagination
              class="pagination-danger"
              [boundaryLinks]="true"
              [totalItems]="45"
              [ngModel]="pagination"
              previousText="&lsaquo;"
              nextText="&rsaquo;"
              firstText="&laquo;"
              lastText="&raquo;"
            >
            </pagination>
            <br />

            <h3 class="mb-5">Labels</h3>
            <span class="badge badge-default mr-1"> Default </span>
            <span class="badge badge-primary mr-1"> Primary </span>
            <span class="badge badge-success mr-1"> Success </span>
            <span class="badge badge-info mr-1"> Info </span>
            <span class="badge badge-warning mr-1"> Warning </span>
            <span class="badge badge-danger mr-1"> Danger </span>
            <span class="badge badge-neutral"> Neutral </span>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="section section-notifications" id="notifications">
      <div class="container">
        <div class="space"></div>
        <h3>Notifications</h3>
        <alert
          class="alert-with-icon"
          [type]="'primary alert-with-icon'"
          [dismissible]="true"
        >
          <span class="tim-icons icon-coins" data-notify="icon"> </span>
          <span>
            <b> Congrats! - </b> This is a regular notification made with
            ".alert-primary"
          </span>
        </alert>
        <alert
          class="alert-with-icon"
          [type]="'info alert-with-icon'"
          [dismissible]="true"
        >
          <span class="tim-icons icon-trophy" data-notify="icon"> </span>
          <span>
            <b> Heads up! - </b> This is a regular notification made with
            ".alert-info"
          </span>
        </alert>
        <alert
          class="alert-with-icon"
          [type]="'success alert-with-icon'"
          [dismissible]="true"
        >
          <span class="tim-icons icon-bell-55" data-notify="icon"> </span>
          <span>
            <b> Well done! - </b> This is a regular notification made with
            ".alert-success"
          </span>
        </alert>
        <alert
          class="alert-with-icon"
          [type]="'warning alert-with-icon'"
          [dismissible]="true"
        >
          <span class="tim-icons icon-bulb-63" data-notify="icon"> </span>
          <span>
            <b> Warning! - </b> This is a regular notification made with
            ".alert-warning"
          </span>
        </alert>
        <alert
          class="alert-with-icon"
          [type]="'danger alert-with-icon'"
          [dismissible]="true"
        >
          <span class="tim-icons icon-support-17" data-notify="icon"> </span>
          <span>
            <b> Oh snap! - </b> This is a regular notification made with
            ".alert-danger"
          </span>
        </alert>
      </div>
    </div>
    <div class="section section-typo">
      <img class="path" src="assets/img/path1.png" />

      <img class="path path1" src="assets/img/path3.png" />

      <div class="container">
        <h3 class="title">Typography</h3>
        <div id="typography">
          <div class="row">
            <div class="col-md-12">
              <div class="typography-line">
                <h1><span> Header 1 </span> The Life of BLK• Design System</h1>
              </div>
              <div class="typography-line">
                <h2><span> Header 2 </span> The Life of BLK• Design System</h2>
              </div>
              <div class="typography-line">
                <h3><span> Header 3 </span> The Life of BLK• Design System</h3>
              </div>
              <div class="typography-line">
                <h4><span> Header 4 </span> The Life of BLK• Design System</h4>
              </div>
              <div class="typography-line">
                <h5><span> Header 5 </span> The Life of BLK• Design System</h5>
              </div>
              <div class="typography-line">
                <h6><span> Header 6 </span> The Life of BLK• Design System</h6>
              </div>
              <div class="typography-line">
                <p>
                  <span> Paragraph </span> I will be the leader of a company
                  that ends up being worth billions of dollars, because I got
                  the answers. I understand culture. I am the nucleus. I think
                  thatâs a responsibility that I have, to push possibilities, to
                  show people, this is the level that things could be at.
                </p>
              </div>
              <div class="typography-line">
                <span> Quote </span>
                <blockquote>
                  <p class="blockquote blockquote-danger">
                    "I will be the leader of a company that ends up being worth
                    billions of dollars, because I got the answers. I understand
                    culture. I am the nucleus. I think thatâs a responsibility
                    that I have, to push possibilities, to show people, this is
                    the level that things could be at." <br />

                    <br />

                    <small> - Noaa </small>
                  </p>
                </blockquote>
              </div>
              <div class="typography-line">
                <span> Muted Text </span>
                <p class="text-muted">
                  I will be the leader of a company that ends up being worth
                  billions of dollars, because I got the answers...
                </p>
              </div>
              <div class="typography-line">
                <span> Primary Text </span>
                <p class="text-primary">
                  I will be the leader of a company that ends up being worth
                  billions of dollars, because I got the answers...
                </p>
              </div>
              <div class="typography-line">
                <span> Info Text </span>
                <p class="text-info">
                  I will be the leader of a company that ends up being worth
                  billions of dollars, because I got the answers...
                </p>
              </div>
              <div class="typography-line">
                <span> Success Text </span>
                <p class="text-success">
                  I will be the leader of a company that ends up being worth
                  billions of dollars, because I got the answers...
                </p>
              </div>
              <div class="typography-line">
                <span> Warning Text </span>
                <p class="text-warning">
                  I will be the leader of a company that ends up being worth
                  billions of dollars, because I got the answers...
                </p>
              </div>
              <div class="typography-line">
                <span> Danger Text </span>
                <p class="text-danger">
                  I will be the leader of a company that ends up being worth
                  billions of dollars, because I got the answers...
                </p>
              </div>
              <div class="typography-line">
                <h2>
                  <span> Small Tag </span> Header with small subtitle <br />

                  <small> Use "small" tag for the headers </small>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="space-50"></div>
        <div id="images">
          <h3 class="mb-5">Images</h3>
          <div class="row">
            <div class="col-sm-3 col-6">
              <small class="d-block text-uppercase font-weight-bold mb-4">
                Image
              </small>
              <img
                alt="Rounded image"
                class="img-fluid rounded shadow"
                src="assets/img/ryan.jpg"
                style="width: 150px;"
              />
            </div>
            <div class="col-sm-3 col-6">
              <small class="d-block text-uppercase font-weight-bold mb-4">
                Circle Image
              </small>
              <img
                alt="Circle image"
                class="img-fluid rounded-circle shadow"
                src="assets/img/james.jpg"
                style="width: 150px;"
              />
            </div>
            <div class="col-sm-3 col-6 mt-5 mt-sm-0">
              <small class="d-block text-uppercase font-weight-bold mb-4">
                Raised
              </small>
              <img
                alt="Raised image"
                class="img-fluid rounded shadow-lg"
                src="assets/img/lora.jpg"
                style="width: 150px;"
              />
            </div>
            <div class="col-sm-3 col-6 mt-5 mt-sm-0">
              <small class="d-block text-uppercase font-weight-bold mb-4">
                Circle Raised
              </small>
              <img
                alt="Raised circle image"
                class="img-fluid rounded-circle shadow-lg"
                src="assets/img/mike.jpg"
                style="width: 150px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-javascript" id="javascriptComponents">
      <img class="path" src="assets/img/path5.png" />

      <img class="path path1" src="assets/img/path5.png" />

      <div class="container">
        <h3 class="title mb-5">Javascript components</h3>
        <h4 class="mb-5">Modal</h4>
        <div class="row" id="modals">
          <div class="col-md-4">
            <button
              class="btn btn-danger"
              data-target="#myModal"
              (click)="myModal.show()"
            >
              Launch Modal
            </button>
          </div>
          <div class="col-md-4">
            <button
              class="btn btn-warning"
              data-target="#myModal1"
              (click)="myModal1.show()"
            >
              Launch Modal Mini
            </button>
          </div>
          <div class="col-md-4">
            <button
              class="btn btn-success"
              data-target="#myModal2"
              (click)="myModal2.show()"
            >
              Launch Modal Form
            </button>
          </div>
        </div>
        <br />

        <br />

        <h4 class="mb-5 mt-3">Datepicker</h4>
        <div class="row">
          <div class="col-md-4">
            <div class="datepicker-container">
              <div class="form-group">
                <input
                  bsDatepicker
                  class="form-control"
                  data-datepicker-color="danger"
                  [bsConfig]="{ isAnimated: true, containerClass: 'theme-red' }"
                  [bsValue]="date"
                  id="datepicker"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h4 class="mb-5 mt-3">Popovers</h4>
            <button
              class="btn btn-default btn-sm mr-1"
              container="body"
              placement="top"
              popoverTitle="Popover on top"
              popover="Here will be some very useful information about his popover."
              type="button"
            >
              On top
            </button>
            <button
              class="btn btn-default btn-sm mr-1"
              container="body"
              placement="right"
              popoverTitle="Popover on right"
              popover="Here will be some very useful information about his popover.<br>
              Here will be some very useful information about his popover."
              type="button"
            >
              On right
            </button>
            <button
              class="btn btn-default btn-sm mr-1"
              container="body"
              placement="bottom"
              popoverTitle="Popover on bottom"
              popover="Here will be some very useful information about his popover."
              type="button"
            >
              On bottom
            </button>
            <button
              class="btn btn-default btn-sm"
              container="body"
              placement="left"
              popoverTitle="Popover on left"
              popover="Here will be some very useful information about his popover."
              type="button"
            >
              On left
            </button>
          </div>
          <div class="col-md-6">
            <h4 class="mb-5 mt-3">Tooltips</h4>
            <button
              class="btn btn-default btn-tooltip btn-sm mr-1"
              data-animation="true"
              data-container="body"
              data-delay="100"
              placement="left"
              tooltip="Tooltip on left"
              type="button"
            >
              On left
            </button>
            <button
              class="btn btn-default btn-tooltip btn-sm mr-1"
              data-animation="true"
              data-container="body"
              placement="top"
              tooltip="Tooltip on top"
              type="button"
            >
              On top
            </button>
            <button
              class="btn btn-default btn-tooltip btn-sm mr-1"
              data-animation="true"
              data-container="body"
              placement="bottom"
              tooltip="Tooltip on bottom"
              type="button"
            >
              On bottom
            </button>
            <button
              class="btn btn-default btn-tooltip btn-sm"
              data-animation="true"
              data-container="body"
              placement="right"
              tooltip="Tooltip on right"
              type="button"
            >
              On right
            </button>
            <div class="clearfix"></div>
            <br />

            <br />
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="title"><h3>Carousel</h3></div>
          <div class="row justify-content-between align-items-center">
            <div class="col-lg-5 mb-5 mb-lg-0">
              <h1 class="text-white font-weight-light">Bootstrap carousel</h1>
              <p class="text-white mt-4">
                Black Design comes with three pre-built pages to help you get
                started faster. You can change the text and images and you're
                good to go.
              </p>
              <a
                class="btn btn-warning mt-4"
                href="https://demos.creative-tim.com/blk-design-system-angular/#/documentation/alerts"
              >
                See all components
              </a>
            </div>
            <div class="col-lg-6">
              <carousel [showIndicators]="false">
                <slide>
                  <img
                    alt="First slide"
                    class="d-block w-100"
                    src="assets/img/denys.jpg"
                  />
                </slide>
                <slide>
                  <img
                    alt="Second slide"
                    class="d-block w-100"
                    src="assets/img/fabien-bazanegue.jpg"
                  />
                </slide>
                <slide>
                  <img
                    alt="Third slide"
                    class="d-block w-100"
                    src="assets/img/mark-finn.jpg"
                  />
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-nucleo-icons">
      <img class="path" src="assets/img/path3.png" />

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-md-12">
            <h2 class="title">Nucleo Icons</h2>
            <h4 class="description">
              BLK• Design System PRO comes with 100 custom icons made by our
              friends from NucleoApp. The official package contains over 2.100
              thin icons which are looking great in combination with BLK• Design
              System PRO Make sure you check all of them and use those that you
              like the most.
            </h4>
            <div class="btn-wrapper">
              <a
                class="btn btn-danger btn-round mr-1"
                href="https://demos.creative-tim.com/blk-design-system-angular/#/documentation/icons"
                target="_blank"
              >
                View Demo Icons
              </a>
              <a
                class="btn btn-danger btn-simple btn-round btn-lg"
                href="https://nucleoapp.com/?ref=1712"
                target="_blank"
              >
                View All Icons
              </a>
            </div>
          </div>
        </div>
        <div class="blur-hover">
          <a
            href="https://demos.creative-tim.com/blk-design-system-angular/#/documentation/icons"
            class="text-danger"
          >
            <div class="icons-container blur-item on-screen mt-5">
              <i class="icon tim-icons icon-coins"> </i>
              <i class="icon icon-sm tim-icons icon-spaceship"> </i>
              <i class="icon icon-sm tim-icons icon-money-coins"> </i>
              <i class="icon icon-sm tim-icons icon-link-72"> </i>
              <i class="icon tim-icons icon-send"> </i>
              <i class="icon tim-icons icon-mobile"> </i>
              <i class="icon tim-icons icon-wifi"> </i>
              <i class="icon icon-sm tim-icons icon-key-25"> </i>
              <i class="icon icon-sm tim-icons icon-atom"> </i>
              <i class="icon icon-sm tim-icons icon-satisfied"> </i>
              <i class="icon tim-icons icon-gift-2"> </i>
              <i class="icon tim-icons icon-tap-02"> </i>
              <i class="icon tim-icons icon-wallet-43"> </i>
            </div>
            <span class="blur-hidden h5 text-danger">
              Eplore all the 21.000+ Nucleo Icons
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="section section-signup">
      <div class="container">
        <div class="squares square-1"></div>
        <div class="squares square-2"></div>
        <div class="squares square-3"></div>
        <div class="squares square-4"></div>
        <div class="row row-grid justify-content-between align-items-center">
          <div class="col-lg-6">
            <h3 class="display-3 text-white">
              A beautiful Black Design
              <span class="text-white"> completed with examples </span>
            </h3>
            <p class="text-white mb-3">
              The Design System comes with four pre-built pages to help you get
              started faster. You can change the text and images and you're good
              to go. More importantly, looking at them will give you a picture
              of what you can built with this powerful Bootstrap 4 Design
              System.
            </p>
            <div class="btn-wrapper">
              <a class="btn btn-danger" [routerLink]="['/register']">
                Register Page
              </a>
            </div>
          </div>
          <div class="col-lg-6 mb-lg-auto">
            <div class="card card-register">
              <div class="card-header">
                <img
                  alt="Card image"
                  class="card-img"
                  src="assets/img/square1-red.png"
                />

                <h4 class="card-title">Register</h4>
              </div>
              <div class="card-body">
                <form class="form">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-single-02"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Full Name"
                      type="text"
                    />
                  </div>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-email-85"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Email"
                      type="text"
                    />
                  </div>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-lock-circle"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Password"
                      type="text"
                    />
                  </div>
                  <div class="form-check text-left">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" />

                      <span class="form-check-sign"> </span> I agree to the
                      <a href="javascript:void(0)"> terms and conditions </a> .
                    </label>
                  </div>
                </form>
              </div>
              <div class="card-footer">
                <a
                  class="btn btn-danger btn-round btn-lg"
                  href="javascript:void(0)"
                >
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-examples" data-background-color="black">
      <img class="path" src="assets/img/path1.png" />

      <div class="space-50"></div>
      <div class="container text-center">
        <div class="row">
          <div class="col-sm-6">
            <a [routerLink]="['/landing']">
              <img
                alt="Image"
                class="img-raised"
                src="assets/img/landing-page.png"
              />
            </a>
            <a
              class="btn btn-simple btn-danger btn-round"
              [routerLink]="['/landing']"
            >
              View Landing Page
            </a>
          </div>
          <div class="col-sm-6">
            <a [routerLink]="['/profile']">
              <img
                alt="Image"
                class="img-raised"
                src="assets/img/profile-page.png"
              />
            </a>
            <a
              class="btn btn-simple btn-danger btn-round"
              [routerLink]="['/profile']"
            >
              View Profile Page
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section section-download" data-background-color="black" #target>
      <img class="path" src="assets/img/path1.png" />

      <div class="container">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-8">
            <h2 class="title">
              Do you love this Bootstrap 4 Angular Design System?
            </h2>
            <h4 class="description">
              Cause if you do, it can be yours for FREE. Hit the button below to
              navigate to Creative Tim where you can find the design system in
              HTML format. Start a new project or give an old Bootstrap project
              a new look!
            </h4>
          </div>
          <div class="text-center col-md-12 col-lg-8">
            <a
              class="btn btn-danger btn-round btn-lg"
              href="https://www.creative-tim.com/product/blk-design-system-angular"
              role="button"
            >
              Download Angular
            </a>
          </div>
        </div>
        <br />

        <br />

        <br />

        <br />

        <br />

        <div class="row row-grid align-items-center my-md">
          <div class="col-lg-6">
            <h3 class="text-danger font-weight-light mb-2">
              Thank you for supporting us!
            </h3>
            <h4 class="mb-0 font-weight-light">
              Let's get in touch on any of these platforms.
            </h4>
          </div>
          <div class="col-lg-6 text-lg-center btn-wrapper">
            <a
              class="btn btn-icon btn-twitter btn-round btn-lg mr-1"
              id="twitter"
            >
              <i class="fab fa-twitter"> </i>
            </a>
            <a
              class="btn btn-icon btn-facebook btn-round btn-lg mr-1"
              id="facebook"
            >
              <i class="fab fa-facebook-square"> </i>
            </a>
            <a
              class="btn btn-icon btn-github btn-round btn-lg"
              href="https://github.com/creativetimofficial"
              target="_blank"
            >
              <i class="fab fa-github"> </i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      aria-labelledby="myModalLabel"
      bsModal
      class="modal fade"
      #myModal="bs-modal"
      id="myModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <button
              aria-hidden="true"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="myModal.hide()"
            >
              <i class="tim-icons icon-simple-remove"> </i>
            </button>
            <h4 class="title title-up">Modal title</h4>
          </div>
          <div class="modal-body">
            <p>
              Far far away, behind the word mountains, far from the countries
              Vokalia and Consonantia, there live the blind texts. Separated
              they live in Bookmarksgrove right at the coast of the Semantics, a
              large language ocean. A small river named Duden flows by their
              place and supplies it with the necessary regelialia. It is a
              paradisematic country, in which roasted parts of sentences fly
              into your mouth.
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" type="button">Nice Button</button>
            <button
              class="btn btn-danger"
              data-dismiss="modal"
              type="button"
              (click)="myModal.hide()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      aria-labelledby="myModalLabel"
      bsModal
      class="modal fade modal-mini modal-danger modal-mini"
      #myModal1="bs-modal"
      id="myModal1"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <button
              aria-hidden="true"
              class="close"
              data-dismiss="modal"
              (click)="myModal1.hide()"
              type="button"
            >
              <i class="tim-icons icon-simple-remove text-white"> </i>
            </button>
            <div class="modal-profile">
              <i class="tim-icons icon-single-02"> </i>
            </div>
          </div>
          <div class="modal-body">
            <p>Always have an access to your profile</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-link btn-neutral" type="button">Back</button>
            <button
              class="btn btn-link btn-neutral"
              data-dismiss="modal"
              type="button"
              (click)="myModal1.hide()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      aria-labelledby="myModalLabel"
      bsModal
      class="modal fade modal-black"
      #myModal2="bs-modal"
      id="myModal2"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <button
              aria-hidden="true"
              class="close"
              data-dismiss="modal"
              (click)="myModal2.hide()"
              type="button"
            >
              <i class="tim-icons icon-simple-remove text-white"> </i>
            </button>
            <div class="text-muted text-center ml-auto mr-auto">
              <h3 class="mb-0">Sign in with</h3>
            </div>
          </div>
          <div class="modal-body">
            <div class="btn-wrapper text-center">
              <a
                class="btn btn-neutral btn-icon mr-1"
                href="javascript:void(0)"
              >
                <img src="assets/img/github.svg" />
              </a>
              <a class="btn btn-neutral btn-icon" href="javascript:void(0)">
                <img src="assets/img/google.svg" />
              </a>
            </div>
            <div class="text-center text-muted mb-4 mt-3">
              <small> Or sign in with credentials </small>
            </div>
            <form role="form">
              <div class="form-group mb-3">
                <div
                  class="input-group input-group-alternative"
                  [ngClass]="{ 'input-group-focus': focus1 === true }"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="tim-icons icon-email-85"> </i>
                    </span>
                  </div>
                  <input
                    class="form-control"
                    placeholder="Email"
                    type="email"
                    (focus)="focus1 = true"
                    (blur)="focus1 = false"
                  />
                </div>
              </div>
              <div class="form-group">
                <div
                  class="input-group input-group-alternative"
                  [ngClass]="{ 'input-group-focus': focus2 === true }"
                >
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="tim-icons icon-key-25"> </i>
                    </span>
                  </div>
                  <input
                    class="form-control"
                    placeholder="Password"
                    type="password"
                    (focus)="focus2 = true"
                    (blur)="focus2 = false"
                  />
                </div>
              </div>
              <div class="form-check mt-3">
                <label class="form-check-label">
                  <input
                    checked="checked"
                    class="form-check-input"
                    type="checkbox"
                  />

                  <span class="form-check-sign"> </span> Remember me!
                </label>
              </div>
              <div class="text-center">
                <button class="btn btn-primary my-4" type="button">
                  Sign in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3"><h1 class="title">BLK•</h1></div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/home']"> Home </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/landing']"> Landing </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/register']"> Register </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/profile']"> Profile </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/contact-us?ref=blkdsa-footer">
                Contact Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/about-us?ref=blkdsa-footer">
                About Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/blog?ref=blkdsa-footer">
                Blog
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://opensource.org/licenses/MIT">
                License
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <h3 class="title">Follow us:</h3>
          <div class="btn-wrapper profile">
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://twitter.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-twitter"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://www.facebook.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-facebook-square"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple"
              href="https://dribbble.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-dribbble"> </i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
